var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":"16px","height":"16px","src":require("@/assets/icon/comment.png"),"alt":"commentIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }